// #region Imports
import Feature from 'ol/Feature.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { easeOut } from 'ol/easing';
import * as olExtent from 'ol/extent';
import GeoJSON from 'ol/format/GeoJSON.js';
import LineString from 'ol/geom/LineString.js';
import Point from 'ol/geom/Point.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorImageLayer from 'ol/layer/VectorImage.js';
import VectorSource from 'ol/source/Vector.js';
import { Fill } from 'ol/style.js';
import { logInit } from '../helpers';
import { styles } from './styles';
import { getUid } from 'ol';
// #endregion
// TODO: afficher les noms des provinces pour les pays autres que la France
// TODO: se service carrément d'une latitude / longitude ?
const { lg } = window;
const COUNTRY_CODE__FR = 'FR';
const ANIMATION_EXTENT_OFFSET = {
    x: -20000,
    y: -20000,
};
class TeaWorldMap {
    constructor(selector, countryCode, provinceCode, customProvinceName) {
        this.selector = selector;
        this.countryCode = countryCode;
        this.provinceCode = provinceCode;
        this.customProvinceName = customProvinceName.trim();
        this.selectedFeature = undefined;
        this.provinceName = '';
        this.displayProvince = countryCode === COUNTRY_CODE__FR && !!provinceCode;
        this.world = { source: undefined, layer: undefined };
        this.province = { source: undefined, layer: undefined };
        this.line = { source: undefined, layer: undefined };
        this.i18n = undefined;
        this._isLoaded = { world: false, province: false, line: false };
        this.mapLoaded = false;
        // this.collection = [];
        // this.collectionByCountries = {};
    }
    offsetExtent(extent, { x, y }) {
        return [extent[0] + x, extent[1] + y, extent[2] + x, extent[3] + y];
    }
    getSelectedFeaturePadding() {
        const size = this.map.getSize();
        const paddingY = Math.floor(size[1] / 3 / 2);
        return [paddingY, 0, paddingY, 0];
    }
    startIntroAnimation() {
        let selectedFeatureExtent = this.selectedFeature.getGeometry().getExtent();
        /** Calculate horizontal offset to center a bit more the province label */
        // const provinceNameLinesMaxLength = styles.label.province
        //   .getText()
        //   .getText()
        //   .filter((text, index) => {
        //     if (index % 2 === 0) return true;
        //     return false;
        //   })
        //   .map((t) => t.length)
        //   .sort(function (a, b) {
        //     return a - b;
        //   })
        //   .at(-1);
        const finalExtentOffset = this.displayProvince && this.provinceName.length !== 0 ? (300000 / 36) * this.provinceName.length : 0;
        const padding = this.getSelectedFeaturePadding();
        /**
         * EDGE CASE: On hardcode les coordonnées pour la France si aucun département n'est sélectionné.
         * Sinon avec les départements d'outre mer on se retrouve avec une vue trop dézoomée
         */
        if (this.countryCode === COUNTRY_CODE__FR && !this.displayProvince) {
            selectedFeatureExtent = [-1553695.964502158, 4912482.153364744, 2076145.6347042918, 6820350.379362743];
        }
        // Set animation source position
        this.view.fit(this.offsetExtent(selectedFeatureExtent, ANIMATION_EXTENT_OFFSET), {
            maxZoom: 4.9,
            padding,
        });
        window.setTimeout(() => {
            this.view.fit(this.offsetExtent(selectedFeatureExtent, { x: finalExtentOffset, y: 0 }), {
                maxZoom: 5,
                duration: 1000,
                padding,
                easing: easeOut,
            });
            if (this.line.layer) {
                window.setTimeout(() => {
                    let currOpacity = 0;
                    function loop() {
                        currOpacity += 0.05;
                        this.line.layer.setOpacity(currOpacity);
                        if (currOpacity < 1)
                            window.requestAnimationFrame(loop.bind(this));
                    }
                    window.requestAnimationFrame(loop.bind(this));
                }, 400);
            }
            this.map.getTargetElement().classList.add('ready');
        }, 200);
    }
    setLoaded(name) {
        this._isLoaded[name] = true;
        if (this._isLoaded.world &&
            (!this.displayProvince || (this.displayProvince && this._isLoaded.province && this._isLoaded.line))) {
            this.startIntroAnimation();
            this.mapLoaded = true;
        }
    }
    // getOpenLayerLibrary() {
    //   return import(/* webpackChunkName: "ol" */ 'ol');
    // }
    get worldMapUrl() {
        return lg.assets.url + `world-low.json?v=${__VERSION__}`;
    }
    get provinceMapUrl() {
        return lg.assets.url + `france-${this.provinceCode}-low.json?v=${__VERSION__}`;
    }
    /*
    fetchCollection() {
      return loadJson(lg.json.teas).then((data) => {
        this.collection = data;
        this.collectionByCountries = mapCollectionToCountries(data);
        this.collectionLoaded = true;
      });
    }
    */
    setView() {
        this.view = new View({
            center: [0, 0],
            zoom: 2,
            showFullExtent: true,
        });
    }
    setWorldMap() {
        this.world.source = new VectorSource({
            url: this.worldMapUrl,
            format: new GeoJSON(),
        });
        this.world.layer = new VectorImageLayer({
            // @ts-expect-error: it works, probably wrong type in source
            background: '#ffffff',
            imageRatio: 4,
            source: this.world.source,
            declutter: true,
            style: (feature, resolution) => {
                const code = feature.get(TeaWorldMap.countryCodeKey);
                const baseStyle = styles.country.base;
                const selectedStyle = styles.country.selected;
                // const countryLabelStyle = styles.label.country;
                // const countryLabelText = countryLabelStyle.getText();
                const isSelected = code === this.countryCode;
                // set fill color based on uid
                const uid = getUid(feature);
                const uid_num = parseInt(uid);
                const color = TeaWorldMap.PALETTE[uid_num % TeaWorldMap.PALETTE.length];
                baseStyle.setFill(new Fill({ color: color }));
                // Render country label if selected and we are not displaying a province
                if (isSelected) {
                    if (this.displayProvince) {
                        // countryLabelText.setText('');
                        return baseStyle;
                    }
                    else {
                        // Only render label for the widest polygon of a multipolygon
                        // let geometry = feature.getGeometry();
                        // if (geometry.getType() === 'MultiPolygon') {
                        //   const polygons = geometry.getPolygons();
                        //   let widest = 0;
                        //   for (let i = 0, ii = polygons.length; i < ii; ++i) {
                        //     const polygon = polygons[i];
                        //     const width = olExtent.getWidth(polygon.getExtent());
                        //     if (width > widest) {
                        //       widest = width;
                        //       geometry = polygon;
                        //     }
                        //   }
                        // }
                        // const name =
                        //   !isDefaultLocale() && lg.i18n?.countries[code]
                        //     ? lg.i18n.countries[code]
                        //     : feature.get(TeaWorldMap.countryNameFrKey);
                        // countryLabelText.setText(name);
                        // countryLabelStyle.setGeometry(geometry);
                        return selectedStyle;
                        // return [selectedStyle, countryLabelStyle];
                    }
                }
                else {
                    return baseStyle;
                }
            },
        });
        this.world.source.once('featuresloadend', () => {
            if (!this.displayProvince) {
                const features = this.world.source.getFeatures();
                for (let i = 0; i < features.length; i++) {
                    const feature = features[i];
                    const properties = feature.getProperties();
                    if (properties[TeaWorldMap.countryCodeKey] === this.countryCode) {
                        this.selectedFeature = feature;
                        break;
                    }
                }
            }
            this.setLoaded('world');
        });
    }
    setProvinceMap() {
        this.province.source = new VectorSource({
            url: this.provinceMapUrl,
            format: new GeoJSON(),
            /** Test Loading multiple features */
            /*
              features: new GeoJSON({
                featureProjection: 'EPSG:3857',
              }).readFeatures(testFeatures),
              */
        });
        this.province.layer = new VectorImageLayer({
            declutter: true,
            imageRatio: 2,
            source: this.province.source,
            style: styles.country.selected,
        });
        this.province.source.once('featuresloadend', () => {
            const lineGeometry = this.line.source.getFeatures()[0].getGeometry();
            const provinceFeature = this.province.source.getFeatures()[0];
            this.selectedFeature = provinceFeature;
            const provinceCenter = olExtent.getCenter(provinceFeature.getGeometry().getExtent());
            lineGeometry.setCoordinates([
                provinceCenter,
                [provinceCenter[0] + 200000, provinceCenter[1] + -50000],
                [provinceCenter[0] + 270000, provinceCenter[1] + -50000],
            ]);
            const lineLastPoint = new Point(lineGeometry.getLastCoordinate());
            this.provinceName =
                this.customProvinceName && this.customProvinceName !== ''
                    ? this.customProvinceName
                    : provinceFeature.get('nom');
            // styles.label.province
            //   .getText()
            //   .setText([
            //     'France',
            //     'bold 14px sans-serif',
            //     '\n',
            //     '',
            //     '',
            //     '22px sans-serif',
            //     this.provinceName,
            //     '11px sans-serif',
            //   ]);
            styles.label.province.getText().setText(this.provinceName);
            styles.label.province.setGeometry(lineLastPoint);
            const provinceSourceExtent = this.province.source.getExtent();
            this.view.fit(provinceSourceExtent, { maxZoom: 5 });
            this.setLoaded('province');
        });
    }
    setLineLabel() {
        this.line.source = new VectorSource({
            features: [new Feature({ geometry: new LineString([]) })],
        });
        this.line.layer = new VectorLayer({
            source: this.line.source,
            opacity: 0,
            // imageRatio: 2,
            style: [styles.label.province, styles.line],
        });
        this.line.layer.once('postrender', () => {
            this.setLoaded('line');
        });
    }
    init() {
        // await this.getOpenLayerLibrary();
        logInit(`Tea World Map (${this.selector})`);
        this.setView();
        this.setWorldMap();
        const layers = [this.world.layer];
        if (this.displayProvince) {
            this.setLineLabel();
            this.setProvinceMap();
            layers.push(this.province.layer);
            layers.push(this.line.layer);
        }
        this.map = new Map({
            // controls: defaultControls().extend([new ShowFullMapControl()]),
            layers,
            target: this.selector,
            view: this.view,
        });
        // TODO: maybe only load when user starts interacting with map ?
        // this.fetchCollection().then(() => {
        //   // update count if map already loaded
        //   if (this.mapLoaded) {
        //     this.map.dataProvider.areas.forEach((area) => (area.value = this.getCountryCounter(area.id)));
        //   }
        // });
    }
    zoomToOriginCountries() {
        // get map from params and not 'this.map' as it can be undefined on first init
        // const zoomDurationOriginal = map.zoomDuration;
        // map.zoomDuration = 0;
        // map.zoomToGroup(ORIGIN_GROUP);
        // map.zoomDuration = zoomDurationOriginal;
    }
    onClickMapObject(event) {
        // const { mapObject } = event;
        // if (mapObject.objectType === 'MapArea') {
        //   if (mapObject.value !== '') {
        //     // update description
        //     const collectionURL = getCountryCollectionUrl(mapObject.id);
        //     if (collectionURL) {
        //       mapObject.description = `<a href="${collectionURL}">${i18n[locale].LINK_TO_COUNTRY_COLLECTION}</a>`;
        //     }
        //     mapObject.validate();
        //   }
        //   this.prevClickedArea = mapObject;
        // }
    }
}
TeaWorldMap.PALETTE = ['#f0ebeb', '#f0e9e9', '#f0e6e6'];
TeaWorldMap.countryCodeKey = 'ISO_A2_EH';
TeaWorldMap.countryNameFrKey = 'NAME_FR';
export default TeaWorldMap;
